import React, { useContext, useEffect, useMemo, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router";
import ContainerBackgroundWrapper from "../components/Backgrounds";
import {
  BloqueLista,
  BloqueTitulo,
  RankingTitle,
  RankingPrizeText,
} from "../styledComponents/TorneoStyled";
import { Apis } from "../util/Apis";
import Text from "../styledComponents/TextStyled";
import { LogoImage } from "../components/LogoCenter";
import NoSorteos from "../components/NoSorteos";
import { getCurrencyConfig } from "../components/services";
import { SiteContext } from "../context/SiteContext";
import { getLogoURL } from "../util/logoUtils";
import CountdownTimer from "../components/CountdownTimer";
import { getCurrentTime } from "../util";
import useGet from "../hooks/useGet";
import { parseDateTime } from "../util/dateUtils";
import CustomLoading from "../components/CustomLoading";
import TournamentRankingTable from "../components/TournamentRankingTable";
import TournamentClassificationClosed from "../components/TournamentClassificationClosed";

const TorneoView = () => {
  const { id } = useParams();
  const { salaId, info } = useContext(SiteContext);
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const couponTypeId = query.get("couponTypeId");
  const navigate = useNavigate();

  const params = { salaId: salaId, couponTypeId: couponTypeId };
  const currencyConfig = getCurrencyConfig();
  const logoImg = info.sala.logo;
  const [hasLoadedOnce, setHasLoadedOnce] = useState(false);

  const { loading: loadingTorneos, data: dataTorneo } = useGet({
    url: Apis.SORTEOS + "/torneos/" + id,
    initialValue: null,
  });

  const { fetchData, loading, data } = useGet({
    url: Apis.PC + "/coupon/group-by-customer",
    params,
  });

  const [now, setNow] = useState(getCurrentTime());

  useEffect(() => {
    const interval = setInterval(() => {
      setNow(getCurrentTime());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {;
    const interval = setInterval(() => {
      fetchData(params);
    }, 5000);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!hasLoadedOnce && !loading && data != null) {
    setHasLoadedOnce(true);
  }

  const fechaHora = dataTorneo?.fechaHora;
  const distance = useMemo(() => {
    if (!fechaHora) {
      return null;
    }

    const tournamentDate = parseDateTime(fechaHora);
    if (!tournamentDate) {
      return null;
    }

    const tournamentMillis = tournamentDate.toMillis();
    return Math.max(tournamentMillis - now, 0);
  }, [fechaHora, now]);

  return (
    <ContainerBackgroundWrapper>
      <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      {loadingTorneos ? (
        <CustomLoading />
      ) : (
        dataTorneo && (
          <BloqueTitulo style={{ flexShrink: 0 }}>
            <LogoImage
              src={getLogoURL(logoImg)}
              alt="logowhite"
              onClick={() => navigate("/sorteo-list")}
            />

            <div
              style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "4px" }}
            >
              <RankingTitle>{dataTorneo.couponTypeName}</RankingTitle>
              <Text>CLASIFICACIÓN</Text>

              {distance !== null && distance > 0 && dataTorneo?.fechaHora && (
                <CountdownTimer targetDate={dataTorneo.fechaHora} />
              )}
            </div>
            <div
              style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "8px" }}
            >
              <RankingPrizeText style={{ color: '#ffffff' }}>PREMIO</RankingPrizeText>
              <RankingPrizeText>
                {currencyConfig.symbol} {dataTorneo.amount}
              </RankingPrizeText>
            </div>
          </BloqueTitulo>
        )
      )}
      {loading && !hasLoadedOnce ? (
        <CustomLoading />
      ) : distance > 0 ? (
        <BloqueLista>
          {!data?.length > 0 ? (
            <NoSorteos>
              <Text textStyle="small">aun no hay jugadores participantes...</Text>
            </NoSorteos>
          ) : (
            <TournamentRankingTable participants={data} />
          )}
        </BloqueLista>
      ) : (
        <TournamentClassificationClosed
          onHome={() => navigate('/sorteo-list')}
          onShowWinner={() => navigate('/torneo-winner/' + couponTypeId)}
        />
      )}
      </div>
    </ContainerBackgroundWrapper>
  );
};

export default TorneoView;
